<template>
  <div id="JobsCard">
    <div
      class="d-flex flex-column justify-content-start  align-items-start bd-highlight mb-3 border-bottom  border-light"
    >
      <h1 class="p-2 bd-highlight" style="font-weight: bold; font-size:36px">
        {{ job.title }}
      </h1>
      <p
        class="p-2 bd-highlight"
        v-html="job.description"
        style="color:#949494"
      ></p>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex">
          <div class="p-2 bd-highlight d-flex align-items-center">
            <img
              src="@/assets/svg/Location.svg"
              style="margin-right:5px"
              alt=""
            />
            {{ job.location }}
          </div>
          <div class="p-2 bd-highlight">
            <img src="@/assets/svg/Work.svg" style="margin-right:5px" alt="" />
            {{ job.workType }}
          </div>
        </div>
        <div
          style="color:#3489E1; font-size:14px; font-weight:700; cursor: pointer;"
          @click="navigate(job._id)"
        >
          Check position
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utility from "../../../assets/js/utilities.services.js";

export default {
  name: "JobsCard",
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {};
  },
  methods: {
    navigate(id) {
      this.$router.push({ path: `/jobs/${id}` });
    },
    substring(str, len = 20) {
      return Utility.substring(str, len);
    },
  },
};
</script>

<style>
.buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.h4,
.imgggg,
.botn-blue {
  cursor: pointer;
}
.imgggg {
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
  width: 260px;
  height: 216px;
  padding: 30px;
}
.botn {
  width: 150px;
  font-size: 16px;
  border-radius: 20px;
  height: 30px;
  outline: none;
  transition: all 0.3s ease;
  border: none;
}
.botn-blue {
  position: relative;
  color: white;
  text-align: center;
  background: linear-gradient(to right, #05cefc, #5659ce);
  font-size: 16px;
}

.image-conatainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#ProductCard {
  border-right: 1px solid grey;
  padding: 10px;
}
</style>
